/**
 * @description 自動補零
 */
function useAutoSupplement(value) {
  if (value < 10) {
    return `0${value}`;
  }
  return value.toString();
}

function useTextProcessing() {
  return {
    useAutoSupplement,
  };
}

export default useTextProcessing;
